import { get } from "./base";

export async function getIndexClassify() {
    let respObj = await get("/edu-classroom/platformconf/gethomedictlistbytype");
    if (respObj != false) {
        // 抽取按学段分类的信息
        let periodInfos = respObj.classroom_period[0].dictDataVoList;
        let periodList = [];
        for (const period of periodInfos) {
            periodList.push({
                name: period.dictLabel,
                code: period.dictCode,
            })
        }
        // 抽取按领域分类的信息
        let areaInfos = respObj.classroom_coursearea;
        let areaList = [];
        for (const info of areaInfos) {
            if (info.dictDataVoList != null) {
                let areaChildren = [];
                for (const child of info.dictDataVoList) {
                    areaChildren.push({
                        name: child.dictLabel,
                        code: child.dictCode
                    });
                }
                areaList.push({
                    name: info.dictName,
                    code: info.dictId,
                    children: areaChildren
                });
            }
        }
        // 抽取按岗层分类的信息
        let postInfos = respObj.classroom_hillock[0].dictDataVoList;
        let postList = [];
        for (const post of postInfos) {
            postList.push({
                name: post.dictLabel,
                code: post.dictCode,
            });
        }
        return [
            { title: "按学段", list: periodList, hasChildren: false },
            { title: "按领域", list: areaList, hasChildren: true },
            { title: "按岗层", list: postList, hasChildren: false },
        ];
    } else {
        // 返回默认顺序
        return [];
    }
}
